// extracted by mini-css-extract-plugin
export default {"title":"imageViewPopUp_title__DsMSn","imageBox":"imageViewPopUp_imageBox__GL8Ey","image":"imageViewPopUp_image__jRiBJ"};